import Cookies from 'universal-cookie';

export default function checkConnected() {
  const cookies = new Cookies();
  return cookies.get('ruach');
}